import React from 'react';

var PullByVersionPopup = React.createClass({
  getInitialState: function(){
    return {value: "Select One", msg: "", showDropdown: false, currentData: [], "sort": "date", "isSort": true}
  },
  handleCloseClick: function(){
    this.props.pullByVersion(false);
  },
  handleSubmitClick: function(){
    var val;
      for (var i in this.state.currentData){
        if (this.state.currentData[i]["checked"]){
          val = this.state.currentData[i]["label"];
        }
      }
      this.props.pullByVersion(false, val);
  },
  componentDidMount: function(){
    // $('.modal__content').css({'position': 'fixed'});
    var data = this.props.data;
    for (var i in data){
      data[i]["checked"] = false;
    }
    this.setState({"currentData": data})
  },
  formatAMPM: function(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes  + ampm;
      return strTime;
  },
  handleChange: function(value){
    var data = this.state.currentData;
    if(value["checked"]){
      for (var i in data){
        if(value["label"] === data[i]["label"] && new Date(value["date"].valueOf() === new Date(data[i]["date"]).valueOf())){
          data[i]["checked"] = false;
        }
      }
    } else {
      for (var i in data){
        if(value["label"] === data[i]["label"] && new Date(value["date"].valueOf() === new Date(data[i]["date"]).valueOf())){
          data[i]["checked"] = true;
        } else {
          data[i]["checked"] = false;
        }
      } 
    }
    this.setState({"data": data});
  },
  handleDateClick: function(){
    this.setState({"sort": "date", isSort: !this.state.isSort});
  },
  handleLabelClick: function(){
    this.setState({"sort": "label", isSort: !this.state.isSort});
  },
  sort: function(sortName){
    if(this.state.sort === "date" && this.state.isSort){
      this.state.currentData.sort(function(a,b){
        return new Date(b.date) - new Date(a.date);  // for sorting date wise
      });
    } else if (this.state.sort === "date" && !this.state.isSort){
      this.props.data.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);  // for sorting date wise
      });
    }

    if(this.state.sort === "label" && this.state.isSort){
      this.state.currentData.sort(function(a, b){
          var nameA=a.label.toLowerCase(), nameB=b.label.toLowerCase()
          if (nameA < nameB) //sort string ascending
              return -1 
          if (nameA > nameB)
              return 1
          return 0 //default return value (no sorting)
      });
    } else if(this.state.sort === "label" && !this.state.isSort) {
      this.state.currentData.sort(function(a, b){
          var nameA=a.label.toLowerCase(), nameB=b.label.toLowerCase()
          if (nameB < nameA) //sort string descending
              return -1 
          if (nameB > nameA)
              return 1
          return 0 //default return value (no sorting)
      });
    }

  },
  handleStopPropogation: function(e) {
    e.stopPropagation() 
  },
  render: function(){
    this.sort(this.state.sort);  // for sortings
    var data = this.state.currentData;
    var flag = false;
    for (var i in data){
      if(this.props.data[i]["canonical"]){
        flag = true;
      }
    }
    /*for the recent date in the data */
    var recentDate = new Date(Math.max.apply(null, data.map(function(e) {
      return new Date(e.date);
    })));
    var result = data.map(function(value, index){
        var date = new Date(value["date"]);
        var dateInString = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(-2) + ", " + this.formatAMPM(date);
        var canon = null;
        if (value["canonical"]){
          canon = <div><i className="fa fa-star" /> <span className="ver__status--visible">canonical</span></div>;
        } else if(!flag && (recentDate.valueOf() === new Date(value.date).valueOf())){
          canon = <div><i className="fa fa-star" /> <span className="ver__status--visible">most recent</span></div>;
        }
        return(<li className="ver__item" key = {index}>
                  <div className="ver__label">
                    <div className="checkbox">
                      <label htmlFor= {index}>
                        <input value="None" name="check" id ={index}  type="checkbox" checked = {value["checked"]} onChange = {this.handleChange.bind(this, value)}/>
                        {value["label"]} </label>
                    </div>
                  </div>
                  <div className="ver__status"> {canon} </div>
                  <div className="ver__date_n_time">{dateInString}</div>
                </li>
                );
    }, this);
    /*code for changing the up and down arrow when click on either label or date*/
    var dateclass, labelclass;
    if(this.state.sort === "date" && this.state.isSort){
      dateclass = "fa fa-angle-up";
      labelclass = "";
    } else if (this.state.sort === "date" && !this.state.isSort){
      dateclass = "fa fa-angle-down";
      labelclass = "";
    } else if (this.state.sort === "label" && this.state.isSort){
      dateclass = "";
      labelclass = "fa fa-angle-up";
    } else if (this.state.sort === "label" && !this.state.isSort){
      dateclass = "";
      labelclass = "fa fa-angle-down";
    }
    return(
      <div className="modal__mask"  onClick = {this.handleCloseClick}>
        <div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
          <div className="modal__header">
            <h3 className="modal__header--title">Pull by Version</h3>
            <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}><i className="fa  fa-close"> </i></a> </div>
          <div className="modal__body clearfix">
            <div className="form__row clearfix">
              <p>Select the version snapshot you want to pull from the hub. Any of your local files may be overridden by files you pull.</p>
            </div>
            <div className="form__row clearfix">
              <div className="ver__container">
                <div className="ver__head clearfix"> 
                  <strong className="ver__head--label ver__head--check">
                    <a href="javascript:void(0)" onClick = {this.handleLabelClick}>Label<i className={labelclass}/></a>
                  </strong>
                  <strong className="ver__head--date ver__head--scroll">
                    <a href="javascript:void(0)" onClick = {this.handleDateClick}>Date <i className={dateclass}/></a>
                  </strong>
                </div>
                <div className="ver__body">
                  <ul className="ver__list list-unstyled">
                    {result}
                  </ul>
                </div>
              </div>
            </div>
            <div className="buttons clearfix">
              <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
              <button className="btn__lg bg-dark" onClick = {this.handleSubmitClick}>Pull Version</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

export {PullByVersionPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/PullByVersionPopup.jsx
 **/